import { config } from '../config/env';

interface TokenResponse {
  // Blanked by the server (SEC-128): the token arrives as an HttpOnly cookie.
  access_token?: string;
  token_type: string;
  expires_in: number;
}

/**
 * Refresh the access token by calling the API's /auth/refresh endpoint.
 * The API reads the refresh token from an HttpOnly cookie and returns a new access token.
 */
export async function exchangeRefreshToken(): Promise<TokenResponse | null> {
  const refreshEndpoint = `${config.apiBaseUrl}/auth/refresh`;

  try {
    const response = await fetch(refreshEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'include', // Important: include cookies in the request
    });

    if (!response.ok) {
      if (response.status === 401) {
        // Refresh token is invalid or expired - user needs to log in again
        return null;
      }
      throw new Error(
        `Token refresh failed: ${response.status} ${response.statusText}`
      );
    }

    const tokenData: TokenResponse = await response.json();
    return tokenData;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return null;
  }
}
